import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Container, Button, HStack } from '@chakra-ui/react';
import { ArrowBackIcon } from '@chakra-ui/icons';
import SearchForm from '../components/SearchForm';
import Results from '../components/Results';

function DNSTool() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [results, setResults] = useState(null);

  const handleSearch = async (domain) => {
    setLoading(true);
    setError(null);
    setResults(null);

    try {
      const apiUrl = process.env.REACT_APP_API_URL || '/api';
      const response = await fetch(`${apiUrl}/lookup`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ domain }),
      });

      const data = await response.json();

      if (data.success) {
        setResults(data);
      } else {
        setError(data.error || 'An error occurred while looking up the domain');
      }
    } catch (err) {
      console.error('Search error:', err);
      setError('Unable to connect to the server. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    setResults(null);
    setError(null);
  };

  return (
    <Box minH="100vh" bg="#0F1419">
      <Container maxW="1200px" py={8}>
        {/* Home Navigation */}
        {!results && (
          <HStack mb={4}>
            <Button
              leftIcon={<ArrowBackIcon />}
              onClick={() => navigate('/')}
              variant="ghost"
              colorScheme="purple"
              size="sm"
              color="gray.400"
              _hover={{ color: 'white', bg: 'whiteAlpha.100' }}
            >
              Back to Tools
            </Button>
          </HStack>
        )}

        {!results && <SearchForm onSearch={handleSearch} loading={loading} error={error} />}
        {results && <Results data={results} onBack={handleBack} />}
      </Container>
    </Box>
  );
}

export default DNSTool;
